import Vue from "vue";
import "vant/lib/button/style";
import "vant/lib/index.css";
import {
  Tab,
  Tabs,
  Rate,
  Icon,
  Cell,
  List,
  Form,
  Swipe,
  Toast,
  Popup,
  Radio,
  Image,
  Field,
  Switch,
  Search,
  Sticky,
  Picker,
  Button,
  Dialog,
  NavBar,
  Loading,
  Divider,
  Popover,
  Stepper,
  Calendar,
  Lazyload,
  Progress,
  Uploader,
  Cascader,
  SwipeCell,
  CellGroup,
  CountDown,
  SwipeItem,
  RadioGroup,
  AddressList,
  AddressEdit,
  ActionSheet,
  ImagePreview,
  PasswordInput,
  DatetimePicker,
  NumberKeyboard,
  PullRefresh,
  Image as VanImage
} from "vant";


Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Rate);
Vue.use(Icon);
Vue.use(Cell);
Vue.use(List);
Vue.use(Form);
Vue.use(Swipe);
Vue.use(Toast);
Vue.use(Popup);
Vue.use(Radio);
Vue.use(Image);
Vue.use(Field);
Vue.use(Switch);
Vue.use(Search);
Vue.use(Sticky);
Vue.use(Picker);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(NavBar);
Vue.use(Loading);
Vue.use(Divider);
Vue.use(Popover);
Vue.use(Stepper);
Vue.use(Calendar);
Vue.use(VanImage);
Vue.use(Lazyload);
Vue.use(Progress);
Vue.use(Uploader);
Vue.use(Cascader);
Vue.use(SwipeCell);
Vue.use(CountDown);
Vue.use(SwipeItem);
Vue.use(CellGroup);
Vue.use(RadioGroup);
Vue.use(AddressList);
Vue.use(AddressEdit);
Vue.use(ActionSheet);
Vue.use(ImagePreview);
Vue.use(PasswordInput);
Vue.use(DatetimePicker);
Vue.use(NumberKeyboard);
Vue.use(PullRefresh);
